import {
    Box,
    Card,
    Collapse,
    Icon,
    IconButton,
    IconButtonProps,
    styled,
} from "@mui/material";
import { useState } from "react";

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
}));

// updated
export default function ExpandableCard(props: {
    children: JSX.Element;
    title: string | JSX.Element;
}) {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Card sx={{ p: 1, mt: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {props.title}

                <ExpandMore expand={expanded} onClick={handleExpandClick}>
                    <Icon>expand_more</Icon>
                </ExpandMore>
            </Box>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                {props.children}
            </Collapse>
        </Card>
    );
}
